// hooks/useDaySchedule.ts
export const useDaySchedule = () => {
    return {
        date: '2025-06-23',
        dayOfWeek: 'Понедельник',
        week: 3,
        sections: [
            {
                period: 'Утро',
                tasks: [
                    {
                        type: 'nutrition',
                        title: 'Завтрак',
                        subtasks: ['Рисовая каша с фруктами', 'Бутерброд с авокадо и яйцом', 'Зелёный чай'],
                    },
                    {
                        type: 'vitamin',
                        title: 'Выпить витамины',
                        note: 'Холин (B4), Аскорбиновая (С), Пиридоксин (B6), Биотин (B7), Цианокобаламин (B12)',
                    },
                ],
                progress: 0,
            },
            {
                period: 'День',
                tasks: [
                    {
                        type: 'nutrition',
                        title: 'Обед',
                        subtasks: ['Куриные котлеты с картофельным пюре', 'Салат из капусты и яблок', 'Компот из яблок'],
                    },
                    {
                        type: 'vitamin',
                        title: 'Выпить витамины',
                        note: 'Холин (B4), Аскорбиновая (С), Пиридоксин (B6), Биотин (B7), Цианокобаламин (B12)',
                    },
                ],
                progress: 0,
            },
            {
                period: 'Вечер',
                tasks: [
                    {
                        type: 'nutrition',
                        title: 'Ужин',
                        subtasks: ['Гречка с грибами', 'Салат из свежих овощей', 'Чай с липой'],
                    },
                    {
                        type: 'exercise',
                        title: 'Динамичная планка на коленях',
                        meta: '3×15',
                    },
                    {
                        type: 'exercise',
                        title: 'Перекрестные касания ладонь-носок в планке',
                        meta: '3×12',
                    },
                    {
                        type: 'exercise',
                        title: 'Русский твист с ногами на весу',
                        meta: '3×15',
                    },
                    {
                        type: 'exercise',
                        title: 'Толчок ногой лежа на животе',
                        meta: '3×12',
                    },
                    {
                        type: 'vitamin',
                        title: 'Выпить витамины',
                        note: 'Холин (B4), Аскорбиновая (С), Пиридоксин (B6), Биотин (B7), Цианокобаламин (B12)',
                    },
                ],
                progress: 17,
            },
        ],
    };
};
